(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Support",
                {
                    url: "/Support",
                    component: "support",
                    PageTitle: "Support",
                    resolve: {
                        userInfo: ["homeApi", "$stateParams", function (homeApi) {
                            return homeApi.getUserInfo().then(function (userModel) {
                                return userModel;
                            });
                        }]
                    }
                });
        }
    ]);

    app.component("support",
        {
            templateUrl: "App/Support/support.html",
            controller: supportCtrl,
            bindings: {
                userInfo: "<"
            }
        });

    supportCtrl.$inject = ["$scope", "emailApi", "$state", "$mdDialog"];


    function supportCtrl($scope, emailApi, $state, $mdDialog) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    loading: false,
                    darkTheme: localStorage.getItem('darkTheme') === 'true' ? true : false
                },
                requestTypes: [
                    { Id: '1', Value: "General Info" },
                    { Id: '2', Value: "FIG Hosting" },
                    { Id: '3', Value: "Email Service" },
                    { Id: '4', Value: "Domain Name" },
                    { Id: '5', Value: "Website Design" },
                    { Id: '6', Value: "Website Updates" }
                ],
                submitTicket: submitTicket,
                submitted: {}
            });

        $scope.$on('themeUpdated', function (event, value) {
            $ctrl.ui.darkTheme = value;
        });

        function submitTicket($event) {
            $ctrl.ui.loading = true;
            var d = new Date();
            var time = d.toLocaleTimeString();
            var date = d.toLocaleDateString();
            var year = d.getFullYear();
            var phoneNumber = $ctrl.userInfo.Phone || "No number given";

            var body = "<html>" +
                            "<head>" +
                                "<meta charset='utf-8'>" +
                                    "<title>FIG Agent Portal Support Message</title>" +
                            "</head>" +
                            "<body>" +
                                "<table width='80%' align='center' cellpadding='0' cellspacing='0'>" +
                                    "<tr>" +
                                        "<td height='80'><span style='display:block; font-size: 25px;' />FIG Agent Portal Support Request</span><br></td>" +
                                    "</tr>" +
                                    "<tr>" +
                                        "<td style='border:#ddd 1px solid;'></td>" +
                                    "</tr>" +
                                    "<tr>" +
                                        "<td style='padding:20px 20px; font-family:Arial, Helvetica, sans-serif; color:#5B5B5B ; line-height:18px;'>" +
                                            "<p>The following support request was submitted via the agent portal at " + time + " on " + date + "</p>" +
                                            "<p><strong>Full Name:</strong> " + $ctrl.userInfo.FullName + "</p>" +
                                            "<p><strong>Email: </strong> " + $ctrl.userInfo.Email + "</p>" +
                                            "<p><strong>Phone: </strong> " + phoneNumber + "</p>" +
                                            //"<p><strong>Request Type: </strong> " + $ctrl.requestType.Value + "</p>" +
                                            "<p><strong>Message: </strong> " + $ctrl.message + "</p>" +
                                        "</td>" +
                                    "</tr>" +
                                    "<tr>" +
                                        "<td style='border:#ddd 1px solid;'></td>" +
                                    "</tr>" +
                                    "<tr>" +
                                        "<td height='30' align='center' style='font-family:Arial, Helvetica, sans-serif; font-size:10px; color:#5B5B5B ;'>" +
                                            "Copyright &copy; " + year + "  All Rights Reserved. <a href='http://www.figmarketing.com'><font color='#5B5B5B '>Financial Independence Group, Inc.</font></font></a>" +
                                        "</td>" +
                                    "</tr>" +
                                "</table>" +
                            "</body>" +
                        "</html>";

            var email = {
                //Subject: "FIG Support - " + $ctrl.requestType.Value + " - " + $ctrl.userInfo.FullName,
                Subject: "FIG Agent Portal Support Request - " + $ctrl.userInfo.FullName,
                Body: body
            };

            emailApi.createAndSendSupportEmail(email, $event).then(function () {
                submit($event);
            }, function (err) {
                error($event);
            });                                 
        }

        function submit($event) {
            var leave = $mdDialog.alert({
                title: "Your request has been submitted. Thank you.",
                targetEvent: $event,
                ariaLabel: "Support request submitted",
                ok: "Continue",
                multiple: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(leave).then(function () {
                $ctrl.ui.loading = false;
                $state.go('Home.Dashboard');
            });
        }

        function error($event) {
            var errorAlert = $mdDialog.alert({
                title: "There was an error processing your request.  Please contact your sales associate for assistance.",
                targetEvent: $event,
                ariaLabel: "Support request error",
                ok: "Ok",
                multiple: true,
                clickOutsideToClose: false
            });
            $ctrl.ui.loading = false;
            $mdDialog.show(errorAlert);
        }

        function init() {
            $ctrl.userInfo.FullName = $ctrl.userInfo.FirstName + " " + $ctrl.userInfo.LastName;
        }

        init();
    }

})(window.app, window.angular); // jshint ignore:line